import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    disableFetchTracking: false,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    maxBatchInterval: 5000,
    samplingPercentage: 100
  }
});

appInsights.loadAppInsights();

// Kept for backward compatibility with existing imports; resolves immediately
const appInsightsReady = Promise.resolve(appInsights);

export { appInsights, appInsightsReady };